var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showDashboard
    ? _c(
        "div",
        [
          _c(
            "v-container",
            { attrs: { fluid: "", "grid-list-xl": "" } },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    md8: "",
                    "offset-md2": "",
                    "margin-auto": ""
                  }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", "text-xs-center": "", "mb-4": "" } },
                    [
                      _c("div", [
                        _c(
                          "div",
                          { staticClass: "left" },
                          [
                            _c("v-select", {
                              staticClass: "selectBox",
                              attrs: {
                                label: "Select States",
                                items: _vm.AllStates,
                                "item-text": "name",
                                "item-value": "code"
                              },
                              on: { change: _vm.getRecordsOf },
                              model: {
                                value: _vm.selectedState,
                                callback: function($$v) {
                                  _vm.selectedState = $$v
                                },
                                expression: "selectedState"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "right" },
                          [
                            _c("v-select", {
                              staticClass: "selectBox",
                              attrs: {
                                label: "Select Status",
                                items: ["Open", "Booked", "Completed"]
                              },
                              on: {
                                change: function($event) {
                                  return _vm.getInstallationOrders2()
                                }
                              },
                              model: {
                                value: _vm.selectedStatus,
                                callback: function($$v) {
                                  _vm.selectedStatus = $$v
                                },
                                expression: "selectedStatus"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mb-5", staticStyle: { clear: "both" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mx-0 border-btn",
                              class: _vm.cmClicked ? "bg-blueish" : "",
                              attrs: { large: "" },
                              on: {
                                click: function($event) {
                                  ;(_vm.cmClicked = true),
                                    (_vm.inClicked = false),
                                    (_vm.selectedType = "CM"),
                                    _vm.getInstallationOrders2()
                                }
                              }
                            },
                            [_vm._v("Check Measure")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mx-0 border-btn",
                              class: _vm.inClicked ? "bg-blueish" : "",
                              attrs: { large: "" },
                              on: {
                                click: function($event) {
                                  ;(_vm.cmClicked = false),
                                    (_vm.inClicked = true),
                                    (_vm.selectedType = "Install"),
                                    _vm.getInstallationOrders2()
                                }
                              }
                            },
                            [_vm._v("Install")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    md8: "",
                    "offset-md2": "",
                    "margin-auto": "",
                    "mt-5": ""
                  }
                },
                [
                  _c(
                    "v-layout",
                    {
                      staticClass:
                        "bg-greyy2 text-xs-center fs24 bold border-bottom2 border",
                      attrs: { row: "", wrap: "" }
                    },
                    [
                      _c("v-flex", { attrs: { "pa-2": "", xs2: "" } }, [
                        _vm._v("\n          Order Code\n        ")
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { "pa-2": "", xs2: "" } }, [
                        _vm._v("\n          Name\n        ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          class: _vm.selectedStatus === "Open" ? "xs4" : "xs3",
                          attrs: { "pa-2": "" }
                        },
                        [_vm._v("\n          Address\n        ")]
                      ),
                      _vm._v(" "),
                      _vm.selectedType === "CM" &&
                      ["Booked", "Completed"].includes(_vm.selectedStatus)
                        ? _c("v-flex", { attrs: { "pa-2": "", xs2: "" } }, [
                            _vm._v("\n          CM Booked Date\n        ")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedType === "Install" &&
                      ["Booked", "Completed"].includes(_vm.selectedStatus)
                        ? _c("v-flex", { attrs: { "pa-2": "", xs2: "" } }, [
                            _vm._v("\n          Install Booked Date\n        ")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { "pa-2": "", xs2: "" } }, [
                        _vm._v("\n          Date Ordered\n        ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          class: _vm.selectedStatus === "Open" ? "xs2" : "xs1",
                          attrs: { "pa-2": "" }
                        },
                        [_vm._v("\n          Actions\n        ")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.loading
                    ? _c(
                        "v-layout",
                        {
                          attrs: {
                            "justify-center": "",
                            "align-center": "",
                            "mt-5": ""
                          }
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _vm.orders.length === 0
                    ? _c(
                        "v-layout",
                        {
                          staticClass: "text-xs-center fs24",
                          attrs: { row: "", wrap: "" }
                        },
                        [
                          _c(
                            "v-flex",
                            { staticClass: "bg-greyy", attrs: { xs12: "" } },
                            [_vm._v("\n          No Record found\n        ")]
                          )
                        ],
                        1
                      )
                    : _vm._l(_vm.orders, function(order, index) {
                        return _c(
                          "v-layout",
                          {
                            key: index,
                            staticClass: "text-xs-center fs24 border",
                            attrs: { row: "", wrap: "" }
                          },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "bg-greyy bold border-right2",
                                attrs: { xs2: "" }
                              },
                              [
                                _c("div", { staticClass: "pa-2" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(order.orderCode) +
                                      "\n          "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs2: "" } }, [
                              _c("div", { staticClass: "pa-2" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(order.customerID.firstName) +
                                    " " +
                                    _vm._s(order.customerID.lastName) +
                                    "\n          "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            order.address && order.differentShippingAddress
                              ? _c(
                                  "v-flex",
                                  {
                                    class:
                                      _vm.selectedStatus === "Open"
                                        ? "xs4"
                                        : "xs3"
                                  },
                                  [
                                    _c("div", { staticClass: "pa-2" }, [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(order.address.address) +
                                          " " +
                                          _vm._s(order.address.city) +
                                          ", " +
                                          _vm._s(order.address.state) +
                                          ", " +
                                          _vm._s(order.address.postcode) +
                                          "\n          "
                                      )
                                    ])
                                  ]
                                )
                              : order.customerID.address
                              ? _c(
                                  "v-flex",
                                  {
                                    class:
                                      _vm.selectedStatus === "Open"
                                        ? "xs4"
                                        : "xs3"
                                  },
                                  [
                                    _c("div", { staticClass: "pa-2" }, [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            order.customerID.address.address
                                          ) +
                                          " " +
                                          _vm._s(
                                            order.customerID.address.city
                                          ) +
                                          ", " +
                                          _vm._s(
                                            order.customerID.address.state
                                          ) +
                                          ", " +
                                          _vm._s(
                                            order.customerID.address.postcode
                                          ) +
                                          "\n          "
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedType === "CM" &&
                            ["Booked", "Completed"].includes(_vm.selectedStatus)
                              ? _c("v-flex", { attrs: { xs2: "" } }, [
                                  _c("div", {
                                    staticClass: "pa-2",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getFormatedDate(order.cmBookedDate)
                                      )
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedType === "Install" &&
                            ["Booked", "Completed"].includes(_vm.selectedStatus)
                              ? _c("v-flex", { attrs: { xs2: "" } }, [
                                  _c("div", {
                                    staticClass: "pa-2",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getFormatedDate(
                                          order.installBookedDate
                                        )
                                      )
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-flex", { attrs: { xs2: "" } }, [
                              _c("div", {
                                staticClass: "pa-2",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getFormatedDate(order.date)
                                  )
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                class:
                                  _vm.selectedStatus === "Open" ? "xs2" : "xs1"
                              },
                              [
                                _c("v-select", {
                                  staticClass: "selectBox2",
                                  attrs: {
                                    items: _vm.actionItems(order, index),
                                    label: "Actions"
                                  },
                                  on: { change: _vm.quoteActions }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-snackbar",
            {
              attrs: { dark: "", top: "", timeout: 3000 },
              model: {
                value: _vm.snackbar,
                callback: function($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar"
              }
            },
            [
              _vm._v("\n    " + _vm._s(_vm.popupText) + "\n    "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  on: {
                    click: function($event) {
                      _vm.snackbar = false
                    }
                  }
                },
                [_vm._v("Close")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "600px" },
              model: {
                value: _vm.bookCMDialog,
                callback: function($$v) {
                  _vm.bookCMDialog = $$v
                },
                expression: "bookCMDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _c("h4", [_vm._v("Book Check Measure")])
                  ]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs10: "",
                            sm6: "",
                            "margin-auto": "",
                            "text-sm-center": ""
                          }
                        },
                        [
                          _c("h2", { staticClass: "my-4" }, [
                            _vm._v("Add CM Book Date and Time ")
                          ]),
                          _vm._v(" "),
                          _c("v-text-field", {
                            staticClass: "xs10",
                            attrs: { label: "CM Booked Date" },
                            on: {
                              click: function($event) {
                                _vm.showDate = true
                              }
                            },
                            model: {
                              value: _vm.datetime,
                              callback: function($$v) {
                                _vm.datetime = $$v
                              },
                              expression: "datetime"
                            }
                          }),
                          _vm._v(" "),
                          !_vm.showDate && !_vm.showTime
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "large-buttons cursor-pointer",
                                  attrs: { color: "grey", dark: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.updateCMBookedDate()
                                    }
                                  }
                                },
                                [_vm._v("Book CM")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showDate
                        ? _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "text-sm-center": ""
                              }
                            },
                            [
                              _c("v-date-picker", {
                                on: { "click:date": _vm.dateClicked },
                                model: {
                                  value: _vm.datePicker,
                                  callback: function($$v) {
                                    _vm.datePicker = $$v
                                  },
                                  expression: "datePicker"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showTime
                        ? _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "text-sm-center": ""
                              }
                            },
                            [
                              _c("v-time-picker", {
                                on: { "click:minute": _vm.minuteClicked },
                                model: {
                                  value: _vm.timePicker,
                                  callback: function($$v) {
                                    _vm.timePicker = $$v
                                  },
                                  expression: "timePicker"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              _vm.bookCMDialog = false
                            }
                          }
                        },
                        [_vm._v("Close")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "600px" },
              model: {
                value: _vm.bookInstallDialog,
                callback: function($$v) {
                  _vm.bookInstallDialog = $$v
                },
                expression: "bookInstallDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_c("h4", [_vm._v("Book Install")])]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs10: "",
                            sm6: "",
                            "margin-auto": "",
                            "text-sm-center": ""
                          }
                        },
                        [
                          _c("h2", { staticClass: "my-4" }, [
                            _vm._v("Add Install Book Date and Time ")
                          ]),
                          _vm._v(" "),
                          _c("v-text-field", {
                            staticClass: "xs10",
                            attrs: { label: "Install Booked Date" },
                            on: {
                              click: function($event) {
                                _vm.showDate = true
                              }
                            },
                            model: {
                              value: _vm.datetime,
                              callback: function($$v) {
                                _vm.datetime = $$v
                              },
                              expression: "datetime"
                            }
                          }),
                          _vm._v(" "),
                          !_vm.showDate && !_vm.showTime
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "large-buttons cursor-pointer",
                                  attrs: { color: "grey", dark: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.updateInstallBookedDate()
                                    }
                                  }
                                },
                                [_vm._v("Book Install")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showDate
                        ? _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "text-sm-center": ""
                              }
                            },
                            [
                              _c("v-date-picker", {
                                on: { "click:date": _vm.dateClicked },
                                model: {
                                  value: _vm.datePicker,
                                  callback: function($$v) {
                                    _vm.datePicker = $$v
                                  },
                                  expression: "datePicker"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showTime
                        ? _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "text-sm-center": ""
                              }
                            },
                            [
                              _c("v-time-picker", {
                                on: { "click:minute": _vm.minuteClicked },
                                model: {
                                  value: _vm.timePicker,
                                  callback: function($$v) {
                                    _vm.timePicker = $$v
                                  },
                                  expression: "timePicker"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              _vm.bookInstallDialog = false
                            }
                          }
                        },
                        [_vm._v("Close")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db613bb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db613bb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InstallDashboardNew.vue
// module id = null
// module chunks = 